const triggerSelect = (container) => {
	$(container || ".selection").on("click", function () {
		$(this).find("select").trigger("mousedown");
	});
};

export default triggerSelect;
